/* eslint-disable @typescript-eslint/naming-convention */
import type { ForwardedRef } from 'react';
import { forwardRef } from 'react';

import { Select as OriginalSelect } from '@change-corgi/design-system-legacy/components/forms';

type Props = React.ComponentProps<typeof OriginalSelect> & {
	isSunriseEnabled: boolean;
};

// eslint-disable-next-line react/display-name
export const Select = forwardRef(
	({ isSunriseEnabled, ...props }: Props, ref: ForwardedRef<HTMLSelectElement>): JSX.Element => {
		const containerSx = {
			'& label span': {
				fontSize: 14,
				fontWeight: 400,
				color: 'sunrise.semantic.typography.strong',
			},

			'& [id$=___error] > span': {
				marginLeft: '-4px',
				color: 'sunrise.semantic.typography.error',
			},

			'& [id$=___error] span svg': {
				marginRight: '4px',
				color: 'sunrise.semantic.icon.error',
			},
			select: {
				borderColor: 'sunrise.semantic.stroke.strong',
				borderWidth: 1,
				borderStyle: 'solid',

				'&:hover': {
					backgroundColor: 'sunrise.semantic.fill.weaker',
					boxShadow: 'none',
				},

				'&:active, &:focus': {
					borderColor: 'sunrise.semantic.stroke.accent.primary.strong',
					backgroundColor: 'sunrise.semantic.fill.inverse.strong',
					boxShadow: 'none',
					borderWidth: 2,
				},

				'&[data-error=true]': {
					borderWidth: 2,
					borderStyle: 'solid',
					borderColor: 'sunrise.semantic.stroke.error.strong',
					boxShadow: 'none',
				},
			},
		};

		return (
			<>
				{isSunriseEnabled ? (
					<div data-qa="input-wrapper-container" sx={containerSx}>
						<OriginalSelect {...props} ref={ref} />
					</div>
				) : (
					<OriginalSelect {...props} ref={ref} />
				)}
			</>
		);
	},
);
